/**
 * @param {string} routingNumber
 * @returns {Promise<{ bank_name: string }>}
 */
export async function getBankInfo(routingNumber) {
  return new Promise((resolve, reject) => {
    window.recurly.bankAccount.bankInfo({ routingNumber }, (error, response) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(response);
    });
  });
}

/**
 * Updates the billing information in Recurly and uses the token to update the billing info in our business systems.
 *
 * @param {HTMLElement} recurlyForm
 * @param {'ach' | 'card'} paymentMethod
 * @returns {Promise<string>} Token returned by recurly after submitting the form
 */
export async function updateRecurly(recurlyForm, paymentMethod = 'card') {
  return new Promise((resolve, reject) => {
    const api = paymentMethod === 'card' ? window.recurly : window.recurly.bankAccount;

    api.token(recurlyForm, (error, token) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(token.id);
    });
  });
}
